import React, { Component } from 'react';
import { withFirebase } from '../../../utils/Firebase';
// import Loading from '../../atoms/Loading';
import FacebookAuth from 'react-facebook-auth';

import { GoogleAuthorize } from 'react-google-authorize';

class LinkAccounts extends Component {

  _initFirebase = false;

  firebaseInit = () => {
    if (this.props.firebase && !this._initFirebase) {
      this._initFirebase = true;
    }
  };

  componentDidMount() {
    this.firebaseInit();
  }

  componentDidUpdate() {
    this.firebaseInit();
  }


  render() {

    const MyFacebookButton = ({ onClick }) => (
        <button onClick={onClick}>
          Sync with facebook
        </button>
      );

      const authenticate = (response) => {
        // Api call to server so we can validate the token
      };

      const responseGoogle = (response) => {
      }

    return (
      <div className="container">
        <h1>Setup your accounts</h1>
        <br/>
        <FacebookAuth
            appId="484811808664490"
            callback={authenticate}
            component={MyFacebookButton}
            scope="ads_management"
            returnScopes={true}
            // scope="email,ads_management,business_management"
        />
 <br/> <br/>
        <div>
        <GoogleAuthorize
            clientId="815121234598-5nn3e2ftm5hobdjbemuappb2t112345.apps.googleusercontent.com"
            buttonText="Sync Google"
            onSuccess={responseGoogle}
            onFailure={responseGoogle}
            scope="openid profile email https://www.googleapis.com/auth/adwords"
        />
        </div>

      </div>
    );
  }
}

export default withFirebase(LinkAccounts);
